export default {"src":"/_next/static/media/icon_circle_1.6ec7f186.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};